{
  "title": "Dispel Magic",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level abjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "Choose any creature, object, or magical effect within range. Any spell of 3rd level or lower on the target ends. For each spell of 4th level or higher on the target, make an ability check using your spellcasting ability. The DC equals 10 + the spell's level. On a successful check, the spell ends.",
    "At Higher Levels. When you cast this spell using a spell slot of 4th level or higher, you automatically end the effects of a spell on the target if the spell's level is equal to or less than the level of the spell slot you used."
  ],
  "spellLists": [
    "artificer",
    "bard",
    "cleric",
    "druid",
    "eldritch-knight",
    "paladin",
    "sorcerer",
    "warlock",
    "wizard"
  ]
}
